import React, { useState, useEffect,useRef } from 'react';
// import { Navbar } from '../navbar/Navbar';
import { Navbar } from '../navbar/Navbar';
import { Col, Container, Row, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import "./PosMobileGlobal.css";
import { MobileOrderDetail } from './Component/MobileOrderDetail';
import { MobileOrderPage } from './Component/MobileOrderPage';
import { MobileOrgTable } from './Component/MobileOrgTable';
import { MobileFoodMenu } from './Component/MobileFoodMenu';
import TableService from '../../../Services/QRCodeServices/TableSerivce/TableService';
import toast from 'react-hot-toast';
import { OrderMenuMobile } from './OrderMenuMobile';





export const POSMobile = () => {
    const [selectedMenu, setSelectedMenu] = useState('food');
    const [orderId, setOrderId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [tables, setTables] = useState([]);
    const [tableWithOrder, setTableWithOrder ] = useState([])
    const [selectedTable, setSelectedTable] = useState(null);
    const [orderPlaced, setOrderPlaced] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const [totalOrders, setTotalOrder]=useState(0)
    const [isUp, setIsUp] = useState(true); // true = up, false = down
    const contentRef = useRef(null);
   


    const toggleHeight = ()=>{
        if(totalOrders > 0){
        setIsExpanded(prev => {
            const newValue = !prev;
      
            // Scroll *after* the DOM updates and animation runs
            if (!prev) {
              setTimeout(() => {
                contentRef.current?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }, 200); // slightly more than the 500ms transition
            } else {
              // Optional: scroll back to top or wherever you want when collapsing
              window.scrollTo({
                top: 10,
                behavior: 'smooth',
              });
            }
      
            return newValue;
          });
        } else {
          setIsExpanded(false);
        }
      setIsUp(prev => !prev);

    }

    useEffect(()=>{
        if(totalOrders<=0){
            setIsExpanded(false)
        }

    },[totalOrders])

    

    const handleOrderClick = (id) => {
        setOrderId(id);
        setSelectedMenu('order-detail');
    };
        // Fetch all tables for display
    
        // const fetchTables = async () => {
        //   try {
        //     const data = await TableService.getList();
        //     data?.map((e)=>{
        //         if(e.isActive && e.isOccupied){
        //             setTableIdWithOrder(prev=> [...prev, e.id])
        //         }
        //     })
        //     // setTables(data);

        //   } catch (error) {
        //     console.error('Error fetching tables:', error);
        //     toast.error('Failed to fetch tables');
        //   }
        // };

        // useEffect(() => {
        //     fetchTables();
        //   }, []);

 

       


        //   useEffect(()=>{

        //     if (selectedTable) {
        //         // fetchOrderedItems();
        //       }

        //   },[selectedTable])
          
    const fetchOrderedItems = () => {
        try {
            const storedData = JSON.parse(localStorage.getItem("orders")) || [];
            console.log(storedData)
            const tableOrder = storedData.find(
            (order) => order.tableID === selectedTable?.id
            );
            console.log(selectedTable)
            console.log(tableOrder)
            if (tableOrder) {
                setTableWithOrder(tableOrder.items);
                // setTableWithOrder(storedData)
            } else {
                setTableWithOrder([]);
            }
        } catch (error) {
            console.error("Error fetching ordered items from localStorage:", error);
            toast.error("Failed to fetch ordered items");
        }
        };

        useEffect(()=>{
            fetchOrderedItems()
        },[orderPlaced, selectedTable])

    const renderComponent = () => {
        switch (selectedMenu) {
            case 'table':
                return <MobileOrgTable />;
            case 'order':
                return <MobileOrderPage onOrderSelect={handleOrderClick} />;
            case 'order-detail':
                return <MobileOrderDetail orderId={orderId} />;
            case 'food':
            default:
                return <MobileFoodMenu searchTerm={searchTerm} selectedTable={selectedTable} setSelectedTable={setSelectedTable} setOrderPlaced={setOrderPlaced} />;
        }
    };


    return (
        <div className=' mt-2 ' style={{minHeight: "90vh", maxHeight: "fit-content"}}>
           

            <Col xs={12}  className='w-100  p-0 m-0 overflow-y-hidden waiterContainerFoodTable'>
                
                    {renderComponent()}  {/* Fixed: Added parentheses to call the function */}
            </Col>

            <div className='py-2  d-flex justify-content-center align-items-center' style={{backgroundColor: "white"}}>

                <input
                type="search"
               
                className="form-control  w-75"
                placeholder="Search items..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                />

            </div>

            <div
                className='expandedCss overflow-hidden   transition-all duration-500 ease-in-out'
                style={{
                    height: isExpanded ? 'fit-content' : '6rem',
                    // height:  contentHeight,
                    position: 'relative',
                    zIndex: isExpanded ? 10 : 1,
                }}
                
                >

                <div
                    className=' text-center text-white  orderSummary  mx-1 mt-sm-3 px-3 '
                    style={{ backgroundColor: '#F3F3F9', height: '100%' }}
                >

                    <div className='py-3 pb-5 fs-4 text-black'  onClick={toggleHeight} style={{cursor: "pointer"}}> {(selectedTable?.identification) ? selectedTable.identification : '' } {(selectedTable?.identification) && <span> :</span> } order summary({ selectedTable ? totalOrders : 0})
                    
                    <span  className="icon-container"  style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i
                        className={`ri-arrow-up-line icon-transition ${isUp ? 'rotate-in' : 'rotate-out'}`}
                        style={{ display: isUp  ? 'inline' : 'none' }}
                        />

                        <i
                        className={`ri-arrow-down-line icon-transition ${!isUp ? 'rotate-in' : 'rotate-out'}`}
                        style={{ display: !isUp ? 'inline' : 'none' }}
                        />
                    </span>


                        </div>

                       
                    <OrderMenuMobile selectedTable={selectedTable} setSelectedTable={setSelectedTable} setTotalOrder={setTotalOrder} contentRef={contentRef}/>
                
                </div>

            </div>

        </div>
    );
};

